import React from 'react';
import { List, Tag } from 'antd';
import { CloseCircleOutlined, WarningOutlined, ApiOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface Recommendation {
  id: string;
  title: string;
  description: string;
  severity: 'high' | 'medium' | 'low';
}

interface RecommendationsListProps {
  recommendations: Recommendation[];
  loading?: boolean;
}

const RecommendationsList: React.FC<RecommendationsListProps> = ({
  recommendations,
  loading = false
}) => {
  const { t } = useTranslation('networks');

  return (
    <List
      loading={loading}
      itemLayout="horizontal"
      dataSource={recommendations}
      locale={{ emptyText: t('noRecommendations', 'No recommendations available') }}
      renderItem={(item: Recommendation) => (
        <List.Item>
          <List.Item.Meta
            avatar={
              item.severity === 'high' ? <CloseCircleOutlined style={{ color: '#f5222d' }} /> :
              item.severity === 'medium' ? <WarningOutlined style={{ color: '#faad14' }} /> :
              <ApiOutlined style={{ color: '#1890ff' }} />
            }
            title={
              <div>
                {item.title}
                <Tag
                  color={
                    item.severity === 'high' ? 'error' :
                    item.severity === 'medium' ? 'warning' : 'processing'
                  }
                  style={{ marginLeft: 8 }}
                >
                  {item.severity === 'high' ? t('severity.high', 'High') :
                   item.severity === 'medium' ? t('severity.medium', 'Medium') :
                   t('severity.low', 'Low')}
                </Tag>
              </div>
            }
            description={item.description}
          />
        </List.Item>
      )}
    />
  );
};

export default RecommendationsList;
